import React, { useState } from "react";
import {
  FiFilter,
  FiDownload,
  FiInfo,
  FiFileText,
  FiDownloadCloud,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import {
  MdOutlineAccountBalanceWallet,
  MdCalendarMonth,
  MdOutlinePercent,
  MdOutlineCheckCircle,
  MdOutlineShoppingCart,
} from "react-icons/md";
import styles from "./Dividend.module.css";
import Sidebar2 from "../../Components/SideBar2/SideBar2";
import Header2 from "../../Components/Header2/Header2";

const summaryCards = [
  {
    id: 1,
    icon: <MdOutlineAccountBalanceWallet />,
    // title: "Total Dividend Earned",
    title: "Dividend Earned",
    amount: "₦352,600.00",
    metric: "All Time",
    iconClass: styles.greenIcon,
  },
  {
    id: 2,
    icon: <MdCalendarMonth />,
    title: "This Year (2024)",
    amount: "₦96,400.00",
    metric: "YTD",
    iconClass: styles.blueIcon,
  },
  {
    id: 3,
    icon: <MdOutlinePercent />,
    title: "Current Dividend Rate",
    amount: "12.50%",
    metric: "Per Annum",
    iconClass: styles.orangeIcon,
  },
  {
    id: 4,
    icon: <MdOutlineCheckCircle />,
    title: "Last Dividend Paid",
    amount: "₦48,200.00",
    metric: "On 28 Mar 2024",
    iconClass: styles.purpleIcon,
  },
];

const tableHeaders = [
  "Year",
  "Dividend Rate (%)",
  "Total Shares",
  "Dividend Earned",
  "Tax (10%)",
  "Net Dividend",
  "Payment Date",
  "Status",
];

const dividendHistory = [
  {
    year: "2024",
    rate: "12.50%",
    shares: "2,000",
    earned: "₦96,400.00",
    tax: "₦9,640.00",
    net: "₦86,760.00",
    date: "28 Mar 2024",
    status: "Paid",
  },
  {
    year: "2023",
    rate: "11.00%",
    shares: "2,000",
    earned: "₦82,500.00",
    tax: "₦8,250.00",
    net: "₦74,250.00",
    date: "31 Mar 2023",
    status: "Paid",
  },
  {
    year: "2022",
    rate: "10.50%",
    shares: "1,500",
    earned: "₦66,150.00",
    tax: "₦6,615.00",
    net: "₦59,535.00",
    date: "29 Mar 2022",
    status: "Paid",
  },
  {
    year: "2021",
    rate: "9.75%",
    shares: "1,200",
    earned: "₦46,800.00",
    tax: "₦4,680.00",
    net: "₦42,120.00",
    date: "30 Mar 2021",
    status: "Paid",
  },
  {
    year: "2020",
    rate: "9.00%",
    shares: "1,000",
    earned: "₦36,000.00",
    tax: "₦3,600.00",
    net: "₦32,400.00",
    date: "25 Mar 2020",
    status: "Paid",
  },
  {
    year: "2019",
    rate: "8.50%",
    shares: "800",
    earned: "₦27,200.00",
    tax: "₦2,720.00",
    net: "₦24,480.00",
    date: "28 Mar 2019",
    status: "Paid",
  },
];

const quickActions = [
  {
    icon: <MdOutlineShoppingCart />,
    title: "Buy More Shares",
  },
  {
    icon: <FiFileText />,
    title: "View Share Statement",
  },
  {
    icon: <FiDownloadCloud />,
    title: "Download Certificates",
  },
];

const TABS = [
  { key: "history", label: "Dividend History" },
  { key: "upcoming", label: "Upcoming Payments" },
];

export default function Dividendss() {
  const [activeTab, setActiveTab] = useState("history");

  return (
    <div className={styles.container}>
      <Sidebar2 active="dividends" />

      <main className={styles.mainContent}>
        <Header2 title="Dividends" />

        <div className={styles.page}>
          <div className={styles.header}>
            <h2>Dividends</h2>
            <p>View your dividend earnings and payment history.</p>
          </div>

           <div className={styles.summaryGrid}>
                {summaryCards.map((card) => (
                  <div className={styles.summaryCard} key={card.id}>
                    <div className={styles.summaryCardBody}>
                      <div className={styles.summaryCardContent}>
                        <div
                          className={`${styles.summaryIcon} ${card.iconClass}`}
                        >
                          {card.icon}
                        </div>
                        <div className={styles.summaryText}>
                          <span>{card.title}</span>
                          <h4>{card.amount}</h4>
                          <small>{card.metric}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

          <div className={styles.contentGrid}>
            {/* ===================== LEFT COLUMN ===================== */}
            <div className={styles.leftColumn}>
              {/* Summary Cards */}
             

              {/* Main Card: tabs + table + info box */}
              <div className={styles.mainCard}>
                {/* Custom tabs (no react-bootstrap) */}
                <div className={styles.tabList} role="tablist">
                  {TABS.map((tab) => (
                    <button
                      key={tab.key}
                      type="button"
                      role="tab"
                      aria-selected={activeTab === tab.key}
                      className={`${styles.tabButton} ${
                        activeTab === tab.key ? styles.tabButtonActive : ""
                      }`}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {activeTab === "history" && (
                  <div className={styles.tabPanel} role="tabpanel">
                    <div className={styles.tableHeader}>
                      <div className={styles.tableButtons}>
                        <button type="button" className={styles.actionBtn}>
                          <FiFilter />
                          Filter
                        </button>

                        <button type="button" className={styles.actionBtn}>
                          <FiDownload />
                          Export
                        </button>
                      </div>
                    </div>

                    <div className={styles.tableResponsive}>
                      <table className={styles.table}>
                        <thead>
                          <tr>
                            {tableHeaders.map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                          </tr>
                        </thead>

                        <tbody>
                          {dividendHistory.map((item, index) => (
                            <tr key={index}>
                              <td>{item.year}</td>
                              <td>{item.rate}</td>
                              <td>{item.shares}</td>
                              <td>{item.earned}</td>
                              <td>{item.tax}</td>
                              <td>{item.net}</td>
                              <td>{item.date}</td>
                              <td>
                                <span className={styles.statusPaid}>
                                  {item.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className={styles.tableFooter}>
                      <span className={styles.recordText}>
                        Showing 1 to 6 of 6 records
                      </span>

                      <div className={styles.pagination}>
                        <button className={styles.pageBtn} type="button">
                          <FiChevronLeft />
                        </button>

                        <button
                          className={`${styles.pageBtn} ${styles.activePage}`}
                          type="button"
                        >
                          1
                        </button>

                        <button className={styles.pageBtn} type="button">
                          <FiChevronRight />
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "upcoming" && (
                  <div className={styles.tabPanel} role="tabpanel">
                    <div className={styles.emptyState}>
                      <h5>No data available</h5>
                      <p>There are currently no upcoming dividend payments.</p>
                    </div>
                  </div>
                )}

                <div className={styles.infoBox}>
                  <div className={styles.infoIcon}>
                    <FiInfo />
                  </div>

                  <div>
                    <h5>About Dividends</h5>
                    <p>
                      Dividends are paid out of the cooperative's surplus
                      after the end of each financial year. The rate is
                      determined by the Board and approved at the Annual
                      General Meeting.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* ===================== RIGHT COLUMN ===================== */}
            <div className={styles.rightColumn}>
              <div className={styles.sideCard}>
                <div className={styles.sideCardBody}>
                  <h4 className={styles.sideTitle}>Dividend Summary</h4>

                  <div className={styles.summaryItem}>
                    <span>Total Dividend Earned (All Time)</span>
                    <h5 className={styles.greenText}>₦352,600.00</h5>
                  </div>

                  <div className={styles.summaryItem}>
                    <span>Total Tax Deducted</span>
                    <h5>₦35,505.00</h5>
                  </div>

                  <div className={styles.summaryItem}>
                    <span>Net Dividend Received</span>
                    <h5>₦317,095.00</h5>
                  </div>

                  <div className={styles.summaryItem}>
                    <span>Average Dividend Rate</span>
                    <h5>10.88%</h5>
                  </div>

                  <button type="button" className={styles.statementBtn}>
                    <FiFileText />
                    View Dividend Statement
                  </button>
                </div>
              </div>

              <div className={styles.sideCard}>
                <div className={styles.sideCardBody}>
                  <h4 className={styles.sideTitle}>Quick Actions</h4>

                  {quickActions.map((action, index) => (
                    <button
                      key={index}
                      type="button"
                      className={styles.quickAction}
                    >
                      <div className={styles.quickLeft}>
                        <span className={styles.quickIcon}>
                          {action.icon}
                        </span>
                        <span>{action.title}</span>
                      </div>

                      <FiChevronRight />
                    </button>
                  ))}
                </div>
              </div>

              <div className={styles.sideCard}>
                <div className={styles.sideCardBody}>
                  <div className={styles.helpHeader}>
                    <div className={styles.helpIcon}>
                      <FiInfo />
                    </div>

                    <div>
                      <h4 className={styles.sideTitle}>Need Help?</h4>
                      <p className={styles.helpText}>
                        Have questions about your dividend payments or how
                        dividends are calculated? Our support team is
                        available to assist you.
                      </p>
                    </div>
                  </div>

                  <button type="button" className={styles.contactBtn}>
                    Contact Support
                  </button>

                  <button type="button" className={styles.faqBtn}>
                    View Dividend FAQ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
